// UI 层
import React from 'react';
import PropTypes from 'prop-types';
import { LazyImg } from '@ifeng-fe/ui_pc_lazyLoad';
// import { getCommonList } from '../service';
import { formatComment } from '@src/public/utils/format';
// icon
import applause from './assets/applause.png';
import slapFace from './assets/slapFace.png';
import thumbsUp from './assets/thumbsUp.png';
// 互动组件
import Interaction from './components/interaction';
// 样式
import classNames from 'classnames';
import styles from './index.css';
import Avatar from './assets/defaultAvatar.png';

const cx = classNames.bind(styles);
// 随机默认头像
const imgList = {
    img_1: 'https://x0.ifengimg.com/ucms/2022_10/2145BC4462D2424F8F6999A887B520087B38BA61_size183_w360_h360.png',
    img_2: 'https://x0.ifengimg.com/ucms/2022_10/A9D1F088D591328B589AAE212942D99C6DA8D231_size150_w360_h360.png',
    img_3: 'https://x0.ifengimg.com/ucms/2022_10/9BA1D8D104F23597F6FE866A3C01A0A9DBCE0F62_size145_w360_h360.png',
    img_4: 'https://x0.ifengimg.com/ucms/2022_10/859D93C49FFB62198DCD9A5F6FD4A4FC12788B8B_size146_w360_h360.png',
    img_5: 'https://x0.ifengimg.com/ucms/2022_10/A275D4274D20584C405D4B184095636B5A13CC1D_size95_w360_h360.png',
};

class Danmu extends React.Component {
    /* 初始化数据*/
    constructor(props) {
        super(props);
        this.state = {
            // UI列表(5)
            list: [],
            // 移动源列表(95)
            list2: [],
            // 数据源列表
            list3: [],
            current: null,
            step: 0,
            totalY: 0,
            translateY: 0,
            toggle: true, // 弹幕开关
            isStop: false, // 暂停开关
            intervalId: null, // 定时器
            isIntervalId: false, // 交互层
            pauseAni: false, // 停顿动画
            siteAdd: 0, // 占位图高度
            isOpacity: true, // 默认开启
            // showDanmu: this.props.showDanmu,
            isBrand: this.props.isBrand,
            dmId: '',
            normalAvater: imgList['img_1'],
            itemHeight: 0, // 项高度
            itemMarginTop: 0, // 项外边距高度
        };
        // 声明引用
        this.listRef = React.createRef();
        this.listWrapRef = React.createRef();
        this.inputRef = React.createRef();
        this.siteRef = React.createRef(); // 占位元素
        this.scrollTimer = React.createRef(null);
        // 函数绑定
        this.count = this.count.bind(this);
    }

    // 添加ui源列表
    uiSource(source) {
        // const source = response.nodes;
        if (source) {
            for (let i = 0; i < source.length; i++) {
                source[i].isShow = false;
                source[i].type = '';
                // 互动数量
                source[i].interaction = [
                    {
                        state: 'thumbsUp',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'thumbsUp',
                    },
                    {
                        state: 'applause',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'applause',
                    },
                    {
                        state: 'slapFace',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'slapFace',
                    },
                ];
            }

            this.setState(state => ({
                list: (state.list = source),
            }));
        }
    }

    // 添加移动源列表
    dataSource(source) {
        // const source = response.nodes;
        try {
            for (let i = 0; i < source.length; i++) {
                source[i].isShow = false;
                source[i].type = '';
                source[i].interaction = [
                    {
                        state: 'thumbsUp',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'thumbsUp',
                    },
                    {
                        state: 'applause',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'applause',
                    },
                    {
                        state: 'slapFace',
                        amount: Math.ceil(Math.random() * 10),
                        icon: 'slapFace',
                    },
                ];
            }

            this.setState(state => ({
                list2: (state.list2 = source),
            }));
        } catch (e) {
            console.log(e);
        }
    }

    componentDidMount() {
        // 设置itemHeight
        this.setItemHeight();

        const { danmu } = this.props;

        if (danmu) {
            // 首次请求进行分解
            const firstFive = danmu?.slice(0, 5);
            const lastFive = danmu?.slice(5, 100);

            // 设置UI列表
            this.uiSource(firstFive);

            // 设置移动源列表
            this.dataSource(lastFive);

            // 设置数据源列表
            this.setState(state => ({
                list3: [...danmu],
            }));

            // 初始自动播放弹幕
            setTimeout(() => {
                this.count();
            }, 0);

            return;
        } else {
            // try {
            //     getCommonList({ id: this.props.id, size: 50 }).then(res => {
            //         // 首次请求进行分解
            //         const firstFive = res?.slice(0, 5);
            //         const lastFive = res?.slice(5, 100);
            //         // 设置UI列表
            //         this.uiSource(firstFive);
            //         // 设置移动源列表
            //         this.dataSource(lastFive);
            //         // 设置数据源列表
            //         this.setState(state => ({
            //             list3: [...res],
            //         }));
            //         // 初始自动播放弹幕
            //         this.count();
            //     });
            // } catch (e) {
            //     console.error(e);
            // }
        }

        // // 监听后台/锁屏状态
        window.document.addEventListener('visibilitychange', () => {
            if (document.hidden) {
                this.stop();
            } else {
                // this.reset();
                this.count(this.state.translateY);
            }
        });
    }

    componentDidUpdate() {
        if (!this.state.isOpacity) {
            console.log('触发透明度');
            this.stop();
        }
    }

    componentWillUnmount() {
        console.log(this.scrollTimer.current);
        window.cancelAnimationFrame(this.scrollTimer.current);
    }

    // componentWillReceiveProps(nextProps) {
    //     var showDanmu = nextProps.showDanmu;

    //     // 只要 props.email 改变，就改变 state
    //     this.hangleToggle();
    // }

    count(props) {
        if (window.requestAnimationFrame) {
            // 当页面第一次加载或者list更新时执行
            // 清除上一次的计时器
            window.cancelAnimationFrame(this.scrollTimer.current);

            // 如果列表为空，则不滚动
            if (!this.state.list.length) {
                return;
            }

            // 获取爷容器
            const listWrapRef = this.listWrapRef.current;
            // 获取爷容器高度
            const listWrapRefHeight = listWrapRef.offsetHeight;

            // 获取父容器列表元素
            const el = this.listRef.current;

            // 获取所有子节点
            const childNodes = el.childNodes;
            // 获取子节点的高度
            const itmeHeight = childNodes[1].offsetHeight + parseInt(getComputedStyle(childNodes[1]).marginTop, 10);
            // 获取当前子节点的外边距
            // var computedStyle = getComputedStyle(childNodes[1], null);
            // var itemMarginBottom = parseInt(computedStyle.marginBottom, 10);

            const translateY = Math.floor(props) || 0;
            let start = -1;

            const step = timestamp => {
                if (start === -1) {
                    start = timestamp;
                }

                // 获取父容器列表
                const listHeight = el.offsetHeight;

                // elapsed:开始到现在时间戳差（ms）,已经过去了多少时间
                const elapsed = timestamp - start;

                // translateY:开始到现在时间差 / 每48ms移动1px = 到现在位移的总距离 =》 无限滚动
                const distance = Math.floor(elapsed / 48);

                // 列表滚动
                el.style.transform = `translateY(-${Math.floor(translateY + distance)}px)`;

                // 记录全局距离 translateY
                this.setState(state => ({
                    translateY: (state.translateY = translateY + distance),
                }));

                // 碰撞检测 =》底部 =》添加新数据
                if (listHeight - (translateY + distance) < listWrapRefHeight) {
                    // console.log("触碰到底部");

                    // B表添加到A底部 一条数据
                    this.setState(
                        state => ({
                            list: state.list.concat(this.state.list2[0]),
                        }),
                        () => {
                            // 添加渐入动画
                            childNodes[childNodes.length - 1].setAttribute('class', 'item show');
                        },
                    );

                    // A表顶部删除一条数据
                    this.setState(state => ({
                        list: state.list.slice(1),
                    }));

                    // B表移除一条数据
                    this.setState(state => ({
                        list2: state.list2.slice(1),
                    }));

                    // B表无数据时请求C表
                    if (this.state.list2.length === 0) {
                        this.setState(state => ({
                            list2: [...state.list2, ...state.list3],
                        }));
                    }

                    // 占位图+1(避免塌陷)：自适应item高度(高度+外边距)
                    // this.state.siteAdd = this.state.siteAdd + itmeHeight + itemMarginBottom;
                    this.state.siteAdd = this.state.siteAdd + itmeHeight;
                    if (this.siteRef.current) {
                        this.siteRef.current.style.height = `${this.state.siteAdd}px`;
                    }
                }

                // 碰撞检测（获取每项节点到爷容器距离）: 添加样式（渐入/渐出）
                for (let i = 0; i < childNodes.length; i++) {
                    // 上检测线（移除）
                    if (childNodes[i].getBoundingClientRect().top <= listWrapRef.getBoundingClientRect().top) {
                        // 排除site元素
                        if (childNodes[i].getAttribute('class') === 'site') {
                            // console.log('什么也不做');
                        } else {
                            childNodes[i].setAttribute('class', 'item hide');
                        }

                        // 碰到下检测线（进入）=> 只计算碰到线
                    } else if (
                        childNodes[i].getBoundingClientRect().top <=
                            listWrapRefHeight + listWrapRef.getBoundingClientRect().top &&
                        childNodes[i].getBoundingClientRect().top >
                            listWrapRefHeight + listWrapRef.getBoundingClientRect().top - 1
                    ) {
                        // childNodes[i].setAttribute("class", "item show");
                        // 只给最后item添加class
                        // childNodes[childNodes.length-1].setAttribute("class", "item show");
                    }
                }

                // 不加限制条件：始终滚动
                this.scrollTimer.current = window.requestAnimationFrame(step);
            };

            this.scrollTimer.current = window.requestAnimationFrame(step);
        }
    }

    // 开始动画
    start() {
        console.log('开始动画');
        this.count();
    }

    // 停止动画
    stop() {
        window.cancelAnimationFrame(this.scrollTimer.current);
    }

    // 重新播放
    reset() {
        console.log('重新播放');
        if (window.requestAnimationFrame) {
            // 当页面第一次加载或者list更新时执行
            // 清除上一次的计时器
            window.cancelAnimationFrame(this.scrollTimer.current);
            // 如果列表为空，则不滚动
            if (!this.state.list.length) {
                return;
            }

            // 获取爷容器
            const listWrapRef = this.listWrapRef.current;
            // 获取爷容器高度
            const listWrapRefHeight = listWrapRef.offsetHeight;

            // 获取父容器列表元素
            const el = this.listRef.current;

            // 获取所有子节点
            const childNodes = el.childNodes;
            // 获取子节点的高度
            const itmeHeight = childNodes[1].offsetHeight + parseInt(getComputedStyle(childNodes[1]).marginTop, 10);
            // 获取当前子节点的外边距
            const computedStyle = getComputedStyle(childNodes[1], null);
            const itemMarginBottom = parseInt(computedStyle.marginBottom, 10);

            let start = -1;
            let totalY = 0;
            const step = timestamp => {
                const translateY = this.state.translateY;

                if (start === -1) {
                    start = timestamp;
                }

                // 获取父容器列表
                const listHeight = el.offsetHeight;

                // elapsed:开始到现在时间戳差（ms）,已经过去了多少时间
                const elapsed = timestamp - start;

                // translateY:开始到现在时间差 / 每48ms移动1px = 到现在位移的总距离 =》 无限滚动
                const distance = elapsed / 48;

                totalY = translateY + distance;

                // console.log("totalY",totalY);
                // 记录全局translateY
                // this.setState(state => ({
                //   translateY:state.translateY = translateY + distance
                // }))

                // 列表滚动
                el.style.transform = `translateY(-${totalY}px)`;

                // 碰撞检测 =》底部 =》添加新数据
                if (listHeight - totalY < listWrapRefHeight) {
                    // console.log("触碰到底部");

                    // B表添加到A底部 一条数据
                    this.setState(
                        state => ({
                            list: state.list.concat(this.state.list2[0]),
                        }),
                        () => {
                            // 添加渐入动画
                            childNodes[childNodes.length - 1].setAttribute('class', 'item show');
                        },
                    );

                    // A表顶部删除一条数据
                    this.setState(state => ({
                        list: state.list.slice(1),
                    }));

                    // B表移除一条数据
                    this.setState(state => ({
                        list2: state.list2.slice(1),
                    }));

                    // B表无数据时请求C表
                    if (this.state.list2.length === 0) {
                        this.setState(state => ({
                            list2: [...state.list2, ...state.list3],
                        }));
                    }

                    // 占位图+1(避免塌陷)：自适应item高度(高度+外边距)
                    this.state.siteAdd = this.state.siteAdd + itmeHeight + itemMarginBottom;
                    if (this.siteRef.current) {
                        this.siteRef.current.style.height = `${this.state.siteAdd}px`;
                    }
                }

                // 碰撞检测（获取每项节点到爷容器距离）: 添加样式（渐入/渐出）
                for (let i = 0; i < childNodes.length; i++) {
                    // 上检测线（移除）
                    if (childNodes[i].getBoundingClientRect().top <= listWrapRef.getBoundingClientRect().top) {
                        // 排除site元素
                        if (childNodes[i].getAttribute('class') === 'site') {
                            // console.log('什么也不做');
                        } else {
                            childNodes[i].setAttribute('class', 'item hide');
                        }

                        // 碰到下检测线（进入）=> 只计算碰到线
                    } else if (
                        childNodes[i].getBoundingClientRect().top <=
                            listWrapRefHeight + listWrapRef.getBoundingClientRect().top &&
                        childNodes[i].getBoundingClientRect().top >
                            listWrapRefHeight + listWrapRef.getBoundingClientRect().top - 1
                    ) {
                        // childNodes[i].setAttribute("class", "item show");
                        // 只给最后item添加class
                        // childNodes[childNodes.length-1].setAttribute("class", "item show");
                    }
                }

                // 不加限制条件：始终滚动
                this.scrollTimer.current = window.requestAnimationFrame(step);
            };

            this.scrollTimer.current = window.requestAnimationFrame(step);
        }
    }

    // 弹幕展示开关
    hangleToggle() {
        // 弹幕开关
        this.setState(
            state => ({
                toggle: !state.toggle,
            }),
            () => {
                // 获取弹幕节点
                // 获取父容器列表元素
                const el = this.listRef.current;
                // const listWrap = document.getElementsByClassName("listWrap")[0];

                // console.log(el.style.opacity);

                if (!this.state.toggle) {
                    // el.style.opacity = 0;
                    el.style.visibility = 'hidden';
                    // this.stop()
                    // // 弹幕关闭
                    // listWrap.style.opacity = 0;
                    // this.setState((state) => ({
                    //   isOpacity: false,
                    // }));
                } else {
                    el.style.visibility = 'visible';
                    // el.style.opacity = 1;
                    // this.reset();
                    // // 弹幕开启
                    // listWrap.style.opacity = 1;
                    // this.setState((state) => ({
                    //   isOpacity: true,
                    // }));
                }
            },
        );
    }

    // 清除弹幕ID
    clearDmId() {
        // 记录上次弹幕id
        this.setState(state => ({
            dmId: (state.dmId = ''),
        }));
    }

    // 交互浮层
    onDanmu(dmId, e) {
        // 深拷贝
        const list = this.state.list;
        // const list2 = JSON.parse(JSON.stringify(list));
        const list2 = list;

        // 获取当前元素数据
        const current = list2.filter(item => item.commentId === dmId)[0];

        // 获取当前DOM
        const event = e.target;

        // 端外点击立即返回
        const isBrand = this.props.isBrand;

        if (isBrand) {
            return;
        }

        // 点击已隐藏元素立即返回
        if (event.closest('.hide')) {
            // console.log('点击了hide元素直接返回');
            return;
        }
        // 设置弹幕ID
        this.setState(state => ({
            dmId: (state.dmId = dmId),
        }));

        // 点击同一个弹幕
        if (dmId && this.state.dmId === dmId) {
            // 重新播放
            this.count(this.state.translateY);
            this.setState(state => ({
                dmId: (state.dmId = ''),
            }));
        } else if (dmId && this.state.dmId !== dmId) {
            // 点击不同弹幕并切换交互浮层
            this.stop();
        }

        // 互动浮层开关
        for (let i = 0; i < list2.length; i++) {
            // 每次只显示单个浮层
            if (list2[i].commentId === dmId) {
                list2[i].isShow = !list2[i].isShow;
            } else {
                // 其余关闭
                list2[i].isShow = false;
            }
        }

        // 获取当前目标浮层
        this.setState(state => ({
            current: (state.current = current),
            isIntervalId: (state.isIntervalId = true),
        }));

        // 重复赋值
        this.setState(
            state => ({
                list: (state.list = list2),
            }),
            () => {},
        );

        // 开启监听:监听全部区域
        this.danmuEventListener();
    }

    // 开启监听:监听全部区域
    danmuEventListener() {
        // 深拷贝
        const list = this.state.list;
        const list2 = list;

        // 获取当前列表容器
        const danmuWrapper = document.getElementById('danmuWrapper');

        // 设置当前列表容器无法穿透；
        danmuWrapper.style.pointerEvents = 'auto';

        danmuWrapper.addEventListener('click', () => {
            // console.log('关闭交互弹窗');
            // 重新播放
            this.count(this.state.translateY);
            this.setState(state => ({
                dmId: (state.dmId = ''),
            }));

            // 关闭互动浮层
            for (let i = 0; i < list2.length; i++) {
                list2[i].isShow = false;
            }
            // 设置点击继续穿透
            danmuWrapper.style.pointerEvents = 'none';

            return;
        });
    }

    // 设置icon
    onAni(name) {
        // 修改当前节点type
        const current = this.state.current;

        this.setState(state => ({
            current: (state.current.type = name),
        }));

        // 替换真实数据
        const list = this.state.list;
        const list2 = list;

        const currentItem = list2.filter(item => item.commentId === current.commentId)[0];

        currentItem.type = name;
        currentItem.isShow = !currentItem.isShow;
        // 清除当前目标
        this.setState(
            state => ({
                current: (state.current = null),
                dmId: (state.dmId = ''), // 清除弹幕ID
            }),
            () => {},
        );

        // 重新播放
        this.count(this.state.translateY);

        // 关闭互动浮层
        for (let i = 0; i < list2.length; i++) {
            list2[i].isShow = false;
        }
    }

    // 弹幕icon展示
    getDanmu(name) {
        let url = '';

        switch (name) {
            case 'applause':
                url = applause;
                break;
            case 'slapFace':
                url = slapFace;
                break;
            case 'thumbsUp':
                url = thumbsUp;
                break;
            default:
                break;
        }

        return url;
    }

    // javascript 如何判断字符串中是否有html代码/标签
    checkHtml(htmlStr) {
        const reg = /<[^>]+>/g;

        return reg.test(htmlStr);
    }

    // 指定随机整数
    randomNum = (...arg) => {
        switch (arg.length) {
            case 1:
                return parseInt(Math.random() * arg[0] + 1, 10);
            case 2:
                return parseInt(Math.random() * (arg[1] - arg[0] + 1) + arg[0], 10);
            default:
                return 0;
        }
    };
    // 随机动态头像
    randomAavter = url => {
        const num = this.randomNum(1, 5);

        if (url) {
            return url;
        } else {
            return this.state.normalAvater;
        }
    };
    // 设置itemHeight
    setItemHeight = () => {
        // 动态计算弹幕高度
        // px=>rem
        const itemHeightRem = 64 / 75; // 64为弹幕设计高度；75为固定参数（2倍设计稿37.5为1倍）
        const itemMarginTopRem = 12 / 75; // 12为弹幕设计外边距高度；75为固定参数（2倍设计稿37.5为1倍）
        // 获取当前html的font-size值
        const htmlFontSize = parseFloat(document.getElementsByTagName('html')[0].style.fontSize, 10);

        // rem=>rpx
        const itemHeightPx = Math.floor(itemHeightRem * htmlFontSize);
        const itemMarginTopPx = Math.floor(itemMarginTopRem * htmlFontSize);

        // alert(`${itemHeightPx }-----${ itemMarginTopPx}`);
        this.setState(state => {
            state.itemHeight = itemHeightPx;
            state.itemMarginTop = itemMarginTopPx;
        });
    };

    render() {
        // 展示UI数据源
        const { list, onhidden, onshow, normalAvater, itemHeight, itemMarginTop } = this.state;
        const doubleList = [...list];

        return (
            <div className={styles.wrapper} id="danmuWrapper">
                <div className={styles.danmu}>
                    {/* 碰撞体 */}
                    <div className={styles.listWrap} ref={this.listWrapRef}>
                        <div className={styles.list} ref={this.listRef} style={{ opacity: 1 }}>
                            <div className="site" ref={this.siteRef} />

                            {doubleList?.length
                                ? doubleList.map((item, index) => {
                                      return (
                                          <div
                                              key={item.commentId}
                                              // key={index}
                                              className={cx({
                                                  item: true,
                                              })}
                                              style={{ height: `${itemHeight}px`, marginTop: `${itemMarginTop}px` }}>
                                              {/* 互动浮层 */}
                                              <Interaction item={item} onClick={state => this.onAni(state)} />

                                              <div
                                                  className={styles.content}
                                                  onClick={this.onDanmu.bind(this, item.commentId)}>
                                                  {/* 懒加载头像 */}
                                                  <LazyImg
                                                      // src={item?.avatar || normalAvater || Avatar}
                                                      src={this.randomAavter(item?.avatar)}
                                                      className={styles.itemheadImg}
                                                  />

                                                  {this.checkHtml(formatComment(item.content)) ? (
                                                      <div
                                                          className={styles.itemText}
                                                          dangerouslySetInnerHTML={{
                                                              __html: formatComment(item.content),
                                                          }}
                                                      />
                                                  ) : (
                                                      <div
                                                          className={styles.itemText}
                                                          style={{
                                                              height: `${itemHeight}px`,
                                                              lineHeight: `${itemHeight}px`,
                                                          }}>
                                                          {item.content}
                                                      </div>
                                                  )}

                                                  {item.type ? (
                                                      <img
                                                          src={this.getDanmu(item.type)}
                                                          className={styles.itemheadImg}
                                                          alt=""
                                                      />
                                                  ) : null}
                                              </div>
                                          </div>
                                      );
                                  })
                                : null}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

Danmu.propTypes = {
    // showDanmu: PropTypes.bool,
    isBrand: PropTypes.bool,
    // id: PropTypes.string,
    danmu: PropTypes.array,
};

export default Danmu;
